/* global Greenhouse */

import Rollbar from 'rollbar/dist/rollbar.umd.min';
import _ from 'underscore';
import { ROLLBAR_SCRUBBED_INPUT_NAME } from './rollbar_scrubbed_input';

const isWebpackStacktrace = function (stack) {
  const lines = stack.split('\n');
  const firstFewLines = lines.slice(0, 4);
  return _.find(firstFewLines, (line) => {
    return line.match(/assets\/webpack/);
  });
};

const isBrowserExtensionError = function (stack) {
  return (
    stack.includes('chrome-extension://') || stack.includes('moz-extension://')
  );
};

// jQuery's UMD returns a factory function (no `.fn`) instead of jQuery when there is no
// `document` at eval time. That only happens in non-browser JS executors (e.g. headless
// DAST scanners that run our bundle without a DOM), where it cascades into chosen's
// `$.fn.extend` (see ignoredMessages below) and a TDZ in legacy/jquery/index.ts. Real
// browsers always have a document, so its absence means there is no user session to help —
// the resulting errors are unactionable noise.
const isDocumentlessExecutor = function () {
  if (typeof window === 'undefined') {
    return false;
  }
  // No DOM at all, or the broken jQuery global it leaves behind: index.ts assigns the bare
  // factory function (a function with no `.fn`) to window.jQuery before the cascade throws.
  return (
    !window.document ||
    (typeof window.jQuery === 'function' && !window.jQuery.fn)
  );
};

/** @knipIgnoreNextLine exported for use in ./rollbar_logger.spec.js  */
export const checkIgnore = (uncaught, rollbarReport) => {
  try {
    if (!uncaught) {
      return false;
    }
    if (isDocumentlessExecutor()) {
      return true;
    }
    const stack = rollbarReport[1].stack;
    if (isBrowserExtensionError(stack)) {
      return true;
    }
    return !isWebpackStacktrace(stack);
  } catch (e) {
    return true;
  }
};

const ROLLBAR_CONFIG = {
  captureUncaught: true,
  captureUnhandledRejections: false,
  // DOM telemetry records every input's value on blur and rides along with any report. Rollbar
  // appends this to its password and card-number defaults and scrubs inputs by `name`, so every
  // Confidential input carries that name (see rollbar_scrubbed_input.ts).
  scrubFields: [ROLLBAR_SCRUBBED_INPUT_NAME],
  checkIgnore: checkIgnore,
  enabled: window.__WEBPACK_SETUP_DATA__.rollbarEnabled,
  ignoredMessages: [
    /Cannot call drop while not dragging./,
    /Cannot read properties of undefined \(reading 'dragging'\)/i,
    /Cannot set properties of undefined \(setting 'dragging'\)/i,
    /<DraggableCore>: Unmounted during event!/i,
    // Duplicate noise from the frontend - if we are failing with a bad status code, we are liking to be seeing this on the backend.
    /Request failed with status code/,
    // Client-side network issues (e.g. flaky connectivity) cause Axios timeouts that are not actionable.
    /timeout exceeded/,
    // Navigating away aborts in-flight XHR requests, which is normal browser behavior.
    /Request aborted/,
    // Client-side network drops trigger Axios onerror with "Network Error", not actionable.
    /Network Error/,
  ],
  accessToken: window.__WEBPACK_SETUP_DATA__.rollbarClientAccessToken,
  payload: {
    client: {
      javascript: {
        code_version: window.__WEBPACK_SETUP_DATA__.gitSha,
        source_map_enabled: true,
      },
    },
    environment: !!__PROD__ ? 'production' : 'development',
    person: {
      id: Greenhouse?.userId,
    },
  },
};

const rollbar = new Rollbar(ROLLBAR_CONFIG);
export default rollbar;
